<template>
  <div class="app-container">
    <list ref="list" @change="onChange">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px;">
      <span>单据明细</span>
    </div>
    <el-table class="tb-c-head" border :data="Details" v-loading="loading" show-summary>
      <!-- <el-table-column label="生产阶段" min-width="90">
        <template slot-scope="{row}">
          <span v-if="row.Stage==0">注塑</span>
          <span v-if="row.Stage==1">胶件加工</span>
          <span v-if="row.Stage==2">配件装配</span>
          <span v-if="row.Stage==3">产品装配</span>
          <span v-if="row.Stage==4">产品组装</span>
        </template>
      </el-table-column>-->
      <el-table-column label="工单编号" min-width="150" show-overflow-tooltip>
        <template slot-scope="{row}">{{row.WorkDocNo}}</template>
      </el-table-column>
      <!-- <el-table-column label="工序" min-width="150" show-overflow-tooltip>
        <template slot-scope="{row}">{{row.ProcessNo}}</template>
      </el-table-column>-->
      <el-table-column label="产品编号" min-width="150">
        <template slot-scope="{row}">{{row.ProductNo}}</template>
      </el-table-column>
      <el-table-column label="产品名称" min-width="150">
        <template slot-scope="{row}">{{row.ProductName}}</template>
      </el-table-column>
      <el-table-column label="产品规格" prop="ProductSpec" min-width="100" />
      <el-table-column label="产品单位" prop="UnitName" min-width="90" />
      <el-table-column label="颜色" prop="ColorName" min-width="90" />
      <el-table-column label="数量" prop="Quantity" width="120" />
      <el-table-column label="加工单价" prop="PocUnitPrice" width="120" />
      <el-table-column label="加工金额" prop="PocAmount" width="120">
        <template slot-scope="{row}">{{row.PocAmount}}</template>
      </el-table-column>
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/outsource/list";
import editDialog from "@/components/finance/dealings/outsource/editDialog";

export default {
  name: "outsource",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      Details: [], //单据明细
      loading: false,
      api: require("@/api/rp/outPocCost").default,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    onChange(row) {
      console.log("选中行", JSON.parse(JSON.stringify(row)));
      this.Details = [];
      this.api.info(row.OutPocCostId).then((res) => {
        if (res.Code == 0) this.Details = res.Data.RpOutPocCostDts;
        console.log(this.Details)
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.OutPocCostId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>